import React from 'react';
import { func, bool, array } from 'prop-types';
import { ModalStyled, ModalActionsStyled, ButtonStyled } from '@nike/nike-design-system-components';

import { TranslatedCopy } from '../../intl/TranslatedCopy';

const ArchiveOrdersModal = ({ isOpen, closeModal, orderIds, onConfirm, isLoading }) => {
  const Actions = () => (
    <ModalActionsStyled>
      <ButtonStyled onClick={onConfirm} disabled={isLoading}>
        {isLoading ? 'Archiving...' : <TranslatedCopy id='global.confirm' />}
      </ButtonStyled>
      <ButtonStyled appearance='secondary' onClick={closeModal} disabled={isLoading}>
        <TranslatedCopy id='global.cancel' />
      </ButtonStyled>
    </ModalActionsStyled>
  );

  return (
    <ModalStyled
      isOpen={isOpen}
      closeModal={() => !isLoading && closeModal()}
      title=''
      slots={{
        HeaderTitleSlot: 'Archive Orders',
        FooterSlot: <Actions />
      }}
    >
      <div>
        <p className='mb4-sm'>Are you sure you want to archive the following orders?</p>
        <ul className='body-4'>
          {orderIds.map(orderId => (
            <li key={orderId}>{orderId}</li>
          ))}
        </ul>
      </div>
    </ModalStyled>
  );
};

ArchiveOrdersModal.propTypes = {
  isOpen: bool.isRequired,
  closeModal: func.isRequired,
  orderIds: array.isRequired,
  onConfirm: func.isRequired,
  isLoading: bool.isRequired
};

export default ArchiveOrdersModal;
